import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filters from 'views/agent/configuration/generateToken/filter'; // Importing Filters component
import Table from 'views/agent/configuration/generateToken/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the generateTokenAgentListView.
 * @extends JetView
 */
export default class generateTokenAgentListView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The layout configuration for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from configuration
                },
            ],
        };

        // Left panel configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label', // Label for the toolbar
                            label: _('Generar Token'), // Translated label text
                            width: 150,
                        },
                    ],
                },
                Filters, // Adding Filters component
                Table, // Adding Table component
                toolbar, // Adding toolbar
            ],
        };

        webix.ui.fullScreen(); // Setting the UI to full screen mode

        // Permission check for displaying the view
        if (!devConfig.getPermAction('AgentConfigurationGenerateTokenMenu', 'Menu')) {
            this.show('./agent.configuration.securityChanges'); // Redirecting if permission is denied
        } else {
            return {
                type: 'wide', // Layout type
                cols: [left], // Columns configuration
            };
        }
    }
}

// FILE DOCUMENTED
